var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"box content__box"},[_c('aside',{staticClass:"aside py--sm"},[_vm._t("aside")],2),_c('main',{staticClass:"main ml--xl mt--md"},[_vm._t("main")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }